
    import {Component,Prop,Vue} from 'vue-property-decorator';

    @Component
    export default class GetHelpForPdf extends Vue {     

        @Prop({required: false, default: false})
        isForm!: boolean;
        
    }
